import { AuditScreenRank } from '../models';
import * as St from '../styles';
import { formatDecimal, formatNumber } from '../utils';
import CardStatus, { CardStatusProps } from './CardStatus';

const TopScreens: React.FC<
  { screens?: AuditScreenRank[] } & CardStatusProps
> = ({ screens = [], loading, error }) => {
  const max = Math.max(...screens.map((screen) => screen.visitas), 1);

  return (
    <St.Card padding={30}>
      <St.CardHeader>
        <St.CardTitle>
          <h3>Telas mais visitadas</h3>
          <span>Rota do front-end, selecione para filtrar</span>
        </St.CardTitle>
        <St.Badge>Por visitas</St.Badge>
      </St.CardHeader>
      <CardStatus loading={loading} error={error} height={383}>
        <St.ScrollList maxHeight={383}>
          {screens.length === 0 && (
            <St.CardStatus height={120}>
              Nenhuma tela visitada no período.
            </St.CardStatus>
          )}
          {screens.map((screen) => (
            <St.ScreenItem key={screen.rota}>
              <header>
                <span>{screen.tela}</span>
                <b>{formatNumber(screen.visitas)} visitas</b>
              </header>
              <small>{screen.rota}</small>
              <St.Progress value={(screen.visitas / max) * 95} />
              <small>
                {formatNumber(screen.chamadasApi)} chamadas API,{' '}
                {formatDecimal(screen.chamadasPorVisita)} por visita,{' '}
                {screen.usuarios} usuários
              </small>
            </St.ScreenItem>
          ))}
        </St.ScrollList>
      </CardStatus>
    </St.Card>
  );
};

export default TopScreens;
